// extracted by mini-css-extract-plugin
export var text = "_q-0";